
import React, { Component } from 'react';
import { Search, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class BookingSearchList extends Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    filterName: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string,
    })).isRequired,
    placeholder: PropTypes.string,
    noResultsMessage: PropTypes.string.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
  }
  static defaultProps = {
    hasSearch: false,
    headerText: 'Find Options',
    options: [],
    placeholder: 'Find Options...',
    value: '',
    disabled: false,
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const showNoResults = props.showNoResults || true;
    return {
      value,
      showNoResults,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSearchList.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSearchList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleClose = () => {
    this.setState({ value: '' }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  handleResultSelect = (e, { result }) => {
    this.props.onSelect(result, this.props.filterName);
  }
  handleSearchChange = (e, { value }) => {
    const showNoResults = true;
    this.setState({
      value,
      showNoResults,
    }, () => {
      this.props.onChange(value);
    });
  }
  render() {
    const classNames = ['booking', 'searchlist'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    return (
      <Search
        aligned="left"
        className={classNames.join(' ')}
        fluid
        icon={this.props.icon || 'caret down'}
        loading={this.props.loading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        results={this.props.results}
        value={this.state.value}
        placeholder={this.props.placeholder}
        noResultsMessage={this.props.noResultsMessage}
        onFocus={() => {
          const showNoResults = false;
          this.setState({ showNoResults });
        }}
        showNoResults={this.state.showNoResults}
        disabled={this.props.disabled}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/BookingSearchList.jsx